import { Component, OnInit } from '@angular/core';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { ConfirmationService, SelectItem } from 'primeng/api';

import { AppComponent } from '@app/app.component';
import { AppDataService } from '@app/core/app-data.service';
import { FederalWithHoldingStatus } from '@app/model/enum/FederalWithHoldingStatus';
import { PersonalInformation } from '@app/model/implementation/PersonalInformation';
import { GeoLocationService } from '@app/services/geolocation.service';
import { IEmployeeService } from '@app/services/interface/IEmployeeService';
import { ServiceFactory } from '@app/services/service.factory';
import { AuthService } from 'cre-ng';
import { faTrafficLightSlow } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-w4form',
  templateUrl: './w4form.component.html',
  styleUrls: ['./w4form.component.css'],
})
export class W4formComponent implements OnInit {
  driverW4Update: PersonalInformation;
  employeeService: IEmployeeService;
  faCaretRight = faCaretRight;
  isDeclaredForm: boolean;
  isSignedForm: boolean;
  states: SelectItem[];
  stateStatus: SelectItem[];
  calculationCodes: SelectItem[];
  showCalculation: boolean;
  clicked: boolean;
  zipCodeFetched: boolean;
  zipsize = false;
  allowedStates: string[] = ['AR', 'AZ', 'CT', 'MA', 'NC', 'ND', 'NE', 'NJ', 'PR', 'WV'];

  constructor(
    private appComponent: AppComponent,
    private appDataService: AppDataService,
    private confirmationService: ConfirmationService,
    public serviceFactory: ServiceFactory,
    private authService: AuthService,
    private geoLocationService: GeoLocationService
  ) {
    this.employeeService = this.serviceFactory.getEmployeeService();
    this.isDeclaredForm = false;
    this.isSignedForm = false;
    this.clicked = false;
    this.zipCodeFetched = false;
    this.showCalculation = false;
  }

  calculateDeductions() {
    this.driverW4Update.federalInfo.qualifiedChildrenAmount =
      this.driverW4Update.federalInfo.qualifiedChildrenCount * 2000;
    this.driverW4Update.federalInfo.otherDependentsAmount =
      this.driverW4Update.federalInfo.otherDependentsCount * 500;

    this.driverW4Update.federalInfo.totalClaimAmount =
      this.driverW4Update.federalInfo.otherDependentsAmount +
      this.driverW4Update.federalInfo.qualifiedChildrenAmount;
  }

  disableSection() {
    if (this.driverW4Update.federalInfo.isExempt) {
      this.driverW4Update.federalInfo.withHoldingStatus = FederalWithHoldingStatus.None;
      this.driverW4Update.federalInfo.twoJobsTotal = false;
      this.driverW4Update.federalInfo.qualifiedChildrenAmount = 0;
      this.driverW4Update.federalInfo.otherDependentsAmount = 0;
      this.driverW4Update.federalInfo.totalClaimAmount = 0;
    } else {
      this.calculateDeductions();
    }
  }

  isShowCalculationsValid() {
    return (
      (this.showCalculation &&
        this.driverW4Update.stateWithholding.alternateCalculationCode !== '') ||
      (!this.showCalculation &&
        this.driverW4Update.stateWithholding.alternateCalculationCode === '')
    );
  }

  isFormValid(): boolean {
    return (
      this.driverW4Update.isValid() &&
      this.isSignedForm &&
      this.isDeclaredForm &&
      this.driverW4Update.stateWithholding.stateWithholding !== '' &&
      this.isShowCalculationsValid() &&
      this.clicked === false
    );
  }

  loadStateStatus() {
    if (this.driverW4Update.address.state) {
      this.driverW4Update.stateWithholding.stateWithholding = '';
      this.employeeService.getStatus(this.driverW4Update.address.state).then((x) => {
        this.stateStatus = x.map((y) => ({
          label: y.description.trim(),
          value: y.status.trim(),
        }));
      });
    }
    this.loadCalculationCode(this.driverW4Update.address.state);
  }

  loadCalculationCode(state: string) {
    // Define the list with alternate calculation code states

    if (this.allowedStates.includes(state)) {
      this.showCalculation = true;
      this.driverW4Update.stateWithholding.alternateCalculationCode = '';
      this.employeeService
        .getAlternateCalculationCode(this.driverW4Update.address.state)
        .then((x) => {
          this.calculationCodes = x.map((y) => ({
            label: y.description.trim(),
            value: y.status.trim(),
          }));
        });
    } else {
      this.showCalculation = false;
    }
  }

  logout(): void {
    void this.authService.invalidateSession().then((success) => {
      if (success) {
        localStorage.removeItem(`cre_${window.__env.ngSettings.sessionAppName}_auth`);
        localStorage.removeItem(`cre_${window.__env.ngSettings.sessionAppName}_expires_at`);
      }
    });
  }

  zipCodeSearch(getFromGeolocation: boolean): void {
    this.zipCodeFetched = false;

    if (this.driverW4Update.address.zip.toString().length === 5) {
      this.zipsize = false;
      if (getFromGeolocation) {
        this.geoLocationService
          .zipCodeInfo(this.driverW4Update.address.zip)
          .then((zipCodeInfo) => {
            this.zipCodeFetched = true;
            this.driverW4Update.address.city = zipCodeInfo.City;
            this.driverW4Update.address.state = zipCodeInfo.State;
          })

          .catch(() => {})
          .finally(() => {});
      }
    } else {
      this.zipsize = true;
    }
  }

  // isInvalidFormField(formFieldName: string): boolean {
  //   const isDirty = this.w4Form.get(formFieldName).dirty;
  //   const isValid = this.w4Form.get(formFieldName).valid;
  //   return !isValid && isDirty;
  // }

  ngOnInit() {
    this.employeeService.getStates().then((x) => {
      this.states = x.map((y) => ({
        label: y.state,
        value: y.state,
      }));
      this.employeeService.getEmployee(1).then((y) => {
        this.driverW4Update = y;
        // Select the state that is comming from etools, if exists
        if (
          this.appDataService.getSelectedState() &&
          this.appDataService.getSelectedState() !== ''
        ) {
          this.driverW4Update.address.state = this.appDataService.getSelectedState();
        }
        if (this.driverW4Update.address.zip.length < 5) {
          this.zipsize = false;
        }
        this.zipCodeSearch(false);
        this.loadStateStatus();
      });
    });
  }

  otherDependantChanged() {
    this.calculateDeductions();
  }

  qualifiedChildrenChanged() {
    this.calculateDeductions();
  }

  filterZip(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Keep only numbers and cut to max 5 digits
    input.value = input.value.replace(/[^0-9]/g, '').slice(0, 5);
    this.driverW4Update.address.zip = input.value;
  }

  saveEmployee() {
    this.appComponent.isTokenValid();
    if (this.appComponent.isValidToken) {
      this.employeeService
        .saveEmployee(this.driverW4Update.toJson())
        .then(() => {
          this.confirmationService.confirm({
            key: 'returnToPortal',
            message:
              'Thank you for completing your W-4.</br>' +
              'It is imperative you validate the updates you made on your pay stub and notify payroll immediately ' +
              'of any discrepancies.</br>Updates may take up to 2 paychecks to take effect.',
            accept: () => {
              this.logout();
              this.appComponent.redirect();
            },
          });
        })
        .catch((e) => {
          if (
            e &&
            e.error &&
            e.error.errors &&
            (e.error.errors.toLowerCase().indexOf('employee') >= 0 ||
              e.error.errors.toLowerCase().indexOf('ssn') >= 0)
          ) {
            const errorMessage =
              'Employee ID or SSN are not found in our records, please contact ' +
              (this.appDataService.getOriginId() === 'career' ? 'Your Admin' : 'Payroll');
            this.confirmationService.confirm({
              key: 'notSaved',
              message: errorMessage,
              accept: () => {},
            });
          } else if (e && e.status === 0) {
            this.confirmationService.confirm({
              key: 'notSaved',
              message: 'Service is not responding, please contact Payroll.',
              accept: () => {},
            });
          } else if (e.status === 401) {
            this.confirmationService.confirm({
              key: 'notSaved',
              message: 'Session has expired, please log in again.',
              accept: () => {
                this.logout();
                this.appComponent.reloadPage();
              },
            });
          } else {
            this.confirmationService.confirm({
              key: 'notSaved',
              message: 'PDF was not created. Please contact Payroll.',
              accept: () => {},
            });
          }
        });
      this.clicked = true;
    } else {
      this.confirmationService.confirm({
        key: 'notSaved',
        message: 'Session has expired, please log in again.',
        accept: () => {
          this.logout();
          this.appComponent.reloadPage();
        },
      });
    }
  }
}
